"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeIssueAttachmentsAction = exports.reducer = exports.loadMoreIssueAttachmentsAction = exports.getTotalNumOfIssueAttachments = exports.getShouldDisplayAttachmentLoadMore = exports.getPaginatedIssueAttachments = exports.getIssueAttachmentsStatus = exports.getIssueAttachmentsState = exports.getIsIssueAttachmentsSuccess = exports.getIsIssueAttachmentsLoading = exports.getIsIssueAttachmentsError = exports.getAllIssueAttachments = exports.fetchIssueAttachmentsAction = exports.addIssueAttachmentsAction = exports.STATE_KEY = exports.PAGINATION_OFFSET = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _fetchHelpers = require("../fetchHelpers");
const initialState = {
  attachmentsMap: {}
};
const PAGINATION_OFFSET = exports.PAGINATION_OFFSET = 6;
const issueAttachmentsCollectionSlice = (0, _toolkit.createSlice)({
  name: "attachments",
  initialState,
  reducers: {
    issueAttachmentsFetchStart: (state, action) => {
      const {
        issueId
      } = action.payload;
      state.attachmentsMap[issueId] = {
        [_fetchHelpers.STATUS_KEY]: _fetchHelpers.FetchStatus.Loading,
        attachments: [],
        numberOfAttachmentsToDisplay: PAGINATION_OFFSET
      };
    },
    issueAttachmentsFetchSuccess: (state, action) => {
      const {
        issueId,
        attachments
      } = action.payload;
      state.attachmentsMap[issueId][_fetchHelpers.STATUS_KEY] = _fetchHelpers.FetchStatus.Success;
      state.attachmentsMap[issueId].attachments = attachments;
    },
    issueAttachmentsFetchFailure: (state, action) => {
      const {
        issueId
      } = action.payload;
      state.attachmentsMap[issueId][_fetchHelpers.STATUS_KEY] = _fetchHelpers.FetchStatus.Error;
    },
    issueAttachmentsRemoveSuccess: (state, action) => {
      const {
        issueId,
        attachmentIdToRemove
      } = action.payload;
      const currentAttachments = state.attachmentsMap[issueId].attachments;
      const newAttachments = currentAttachments.filter(attachment => attachmentIdToRemove !== attachment.attachmentId);
      state.attachmentsMap[issueId].attachments = newAttachments;
    },
    issueAttachmentsAddSuccess: (state, action) => {
      const {
        issueId,
        attachment
      } = action.payload;
      if (!state.attachmentsMap[issueId]) {
        state.attachmentsMap[issueId] = {
          [_fetchHelpers.STATUS_KEY]: _fetchHelpers.FetchStatus.Success,
          attachments: [],
          numberOfAttachmentsToDisplay: PAGINATION_OFFSET
        };
      }
      state.attachmentsMap[issueId].attachments.push(attachment);
      const newAttachmentsLength = state.attachmentsMap[issueId].attachments.length;
      if (newAttachmentsLength > PAGINATION_OFFSET) {
        state.attachmentsMap[issueId].numberOfAttachmentsToDisplay += 1;
      }
    },
    issueAttachmentsLoadMore: (state, action) => {
      const {
        issueId
      } = action.payload;
      state.attachmentsMap[issueId].numberOfAttachmentsToDisplay += PAGINATION_OFFSET;
    }
  }
});
const {
  issueAttachmentsFetchStart,
  issueAttachmentsFetchSuccess,
  issueAttachmentsFetchFailure,
  issueAttachmentsAddSuccess,
  issueAttachmentsRemoveSuccess,
  issueAttachmentsLoadMore
} = issueAttachmentsCollectionSlice.actions;
const fetchIssueAttachmentsAction = (issueId, usersEntitiesMap) => async (dispatch, getState, _ref) => {
  let {
    sdk
  } = _ref;
  dispatch(issueAttachmentsFetchStart({
    issueId
  }));
  try {
    const issueAttachments = await sdk.IssueAttachments.get(issueId);

    //A workaround until the createdBy that is returned from the API is supported by the Attachments component
    issueAttachments.forEach(attachment => {
      var _usersEntitiesMap$att;
      attachment.createdByName = (_usersEntitiesMap$att = usersEntitiesMap[attachment.createdBy]) === null || _usersEntitiesMap$att === void 0 ? void 0 : _usersEntitiesMap$att.name;
    });
    dispatch(issueAttachmentsFetchSuccess({
      issueId,
      attachments: issueAttachments
    }));
  } catch (e) {
    dispatch(issueAttachmentsFetchFailure({
      issueId
    }));
  }
};
exports.fetchIssueAttachmentsAction = fetchIssueAttachmentsAction;
const addIssueAttachmentsAction = _ref2 => {
  let {
    issueId,
    newAttachmentData,
    usersEntitiesMap
  } = _ref2;
  return async (dispatch, getState, _ref3) => {
    var _usersEntitiesMap$new;
    let {
      sdk
    } = _ref3;
    //No try and catch here because the error is handled by the Attachments component
    const newAttachments = await sdk.IssueAttachments.create(newAttachmentData);
    const newAttachment = newAttachments[0];

    //A workaround until the createdBy that is returned from the API is supported by the Attachments component
    newAttachment.createdByName = (_usersEntitiesMap$new = usersEntitiesMap[newAttachment.createdBy]) === null || _usersEntitiesMap$new === void 0 ? void 0 : _usersEntitiesMap$new.name;
    dispatch(issueAttachmentsAddSuccess({
      issueId,
      attachment: newAttachment
    }));
  };
};
exports.addIssueAttachmentsAction = addIssueAttachmentsAction;
const removeIssueAttachmentsAction = _ref4 => {
  let {
    issueId,
    attachmentId
  } = _ref4;
  return async (dispatch, getState, _ref5) => {
    let {
      sdk
    } = _ref5;
    //No try and catch here because the error is handled by the Attachments component
    await sdk.IssueAttachments.delete(issueId, attachmentId);
    dispatch(issueAttachmentsRemoveSuccess({
      issueId,
      attachmentIdToRemove: attachmentId
    }));
  };
};
exports.removeIssueAttachmentsAction = removeIssueAttachmentsAction;
const loadMoreIssueAttachmentsAction = issueId => dispatch => {
  dispatch(issueAttachmentsLoadMore({
    issueId
  }));
};
exports.loadMoreIssueAttachmentsAction = loadMoreIssueAttachmentsAction;
const reducer = exports.reducer = issueAttachmentsCollectionSlice.reducer;
const STATE_KEY = exports.STATE_KEY = issueAttachmentsCollectionSlice.name;
const getIssueAttachmentsState = state => {
  return state[STATE_KEY];
};
exports.getIssueAttachmentsState = getIssueAttachmentsState;
const getAllIssueAttachments = exports.getAllIssueAttachments = (0, _toolkit.createSelector)(getIssueAttachmentsState, attachmentsState => issueId => {
  var _attachmentsState$att, _attachmentsState$att2;
  if (!issueId) {
    return [];
  }
  const attachments = (_attachmentsState$att = (_attachmentsState$att2 = attachmentsState.attachmentsMap[issueId]) === null || _attachmentsState$att2 === void 0 ? void 0 : _attachmentsState$att2.attachments) !== null && _attachmentsState$att !== void 0 ? _attachmentsState$att : [];
  return attachments;
});
const getTotalNumOfIssueAttachments = exports.getTotalNumOfIssueAttachments = (0, _toolkit.createSelector)(getAllIssueAttachments, allIssueAttachmentsGetter => issueId => {
  return allIssueAttachmentsGetter(issueId).length;
});
const getShouldDisplayAttachmentLoadMore = exports.getShouldDisplayAttachmentLoadMore = (0, _toolkit.createSelector)(getIssueAttachmentsState, attachmentsState => issueId => {
  var _issueAttachmentData$;
  const issueAttachmentData = attachmentsState.attachmentsMap[issueId];
  const allAttachments = (_issueAttachmentData$ = issueAttachmentData === null || issueAttachmentData === void 0 ? void 0 : issueAttachmentData.attachments) !== null && _issueAttachmentData$ !== void 0 ? _issueAttachmentData$ : [];
  const totalNumOfAttachments = allAttachments.length;
  const numberOfAttachmentsToDisplay = (issueAttachmentData === null || issueAttachmentData === void 0 ? void 0 : issueAttachmentData.numberOfAttachmentsToDisplay) || 0;
  return totalNumOfAttachments > numberOfAttachmentsToDisplay;
});
const getPaginatedIssueAttachments = exports.getPaginatedIssueAttachments = (0, _toolkit.createSelector)(getIssueAttachmentsState, attachmentsState => issueId => {
  var _issueAttachmentData$2;
  if (!issueId) {
    return [];
  }
  const issueAttachmentData = attachmentsState.attachmentsMap[issueId];
  const allAttachments = (_issueAttachmentData$2 = issueAttachmentData === null || issueAttachmentData === void 0 ? void 0 : issueAttachmentData.attachments) !== null && _issueAttachmentData$2 !== void 0 ? _issueAttachmentData$2 : [];
  return allAttachments.slice(0, (issueAttachmentData === null || issueAttachmentData === void 0 ? void 0 : issueAttachmentData.numberOfAttachmentsToDisplay) || 0);
});
const getIssueAttachmentsStatus = exports.getIssueAttachmentsStatus = (0, _toolkit.createSelector)(getIssueAttachmentsState, attachmentsState => issueId => {
  var _attachmentsState$att3;
  if (!issueId) {
    return undefined;
  }
  const status = (_attachmentsState$att3 = attachmentsState.attachmentsMap[issueId]) === null || _attachmentsState$att3 === void 0 ? void 0 : _attachmentsState$att3.status;
  return status;
});
const getIsIssueAttachmentsLoading = exports.getIsIssueAttachmentsLoading = (0, _toolkit.createSelector)(getIssueAttachmentsStatus, issueAttachmentsStatusGetter => issueId => {
  const status = issueAttachmentsStatusGetter(issueId);
  return status === _fetchHelpers.FetchStatus.Loading;
});
const getIsIssueAttachmentsError = exports.getIsIssueAttachmentsError = (0, _toolkit.createSelector)(getIssueAttachmentsStatus, issueAttachmentsStatusGetter => issueId => {
  const status = issueAttachmentsStatusGetter(issueId);
  return status === _fetchHelpers.FetchStatus.Error;
});
const getIsIssueAttachmentsSuccess = exports.getIsIssueAttachmentsSuccess = (0, _toolkit.createSelector)(getIssueAttachmentsStatus, issueAttachmentsStatusGetter => issueId => {
  const status = issueAttachmentsStatusGetter(issueId);
  return status === _fetchHelpers.FetchStatus.Success;
});
//# sourceMappingURL=issueAttachments.js.map